export default __webpack_public_path__ + "static/media/Butter.22a6895e.jpg";